import React from "react";
import stripeLogo from "../images/landing-page/new/stripe.png";
import googleLogo from "../images/landing-page/new/Google.png";
import cleverLogo from "../images/landing-page/new/Clever.png";
import "../styles/landing-page.css";

export default function PartnershipsBar() {
    return (
        <section className="landing-partnerships">
            <div className="landing-partnerships-header">
                <p className="landing-section-label landing-section-label--dark">
                    <span className="landing-section-label-diamond">◆</span> Integrations
                </p>
                <h2 className="landing-partnerships-heading">Our Partnerships</h2>
            </div>
            <div className="landing-partnerships-grid">
                <div className="landing-partner-card landing-partner-card--detail">
                    <img src={stripeLogo} alt="Stripe" className="landing-partner-logo" />
                    <h3 className="landing-partner-card-title">Stripe Partnership</h3>
                    <p className="landing-partner-card-desc">
                        All billing and payments are handled securely through Stripe, one of the most trusted
                        payment platforms. Billing is secure, reliable, and easy to manage.
                    </p>
                </div>
                <div className="landing-partner-card landing-partner-card--detail">
                    <img src={googleLogo} alt="Google" className="landing-partner-logo" />
                    <h3 className="landing-partner-card-title">Google Partnership</h3>
                    <p className="landing-partner-card-desc">
                        Sync your Google Calendar and Google Drive with Polaris Athlete Hub. Enjoy seamless
                        SSO login via Google, making it easy for athletes, coaches, and staff to access
                        everything they need without extra credentials.
                    </p>
                </div>
                <div className="landing-partner-card landing-partner-card--detail">
                    <img src={cleverLogo} alt="Clever" className="landing-partner-logo" />
                    <h3 className="landing-partner-card-title">Clever Partnership</h3>
                    <p className="landing-partner-card-desc">
                        We integrate seamlessly with Clever to provide secure, streamlined SSO login. Your
                        school or organization can manage users with confidence, knowing access is safe,
                        simple, and centralized.
                    </p>
                </div>
            </div>
        </section>
    );
}
